export default __webpack_public_path__ + "static/media/Visual_joil_14.581135bc.jpg";